import React from 'react';
import { Link } from 'react-router-dom';
import { Container, Button } from '../../globalStyles';
import {
  InfoSec,
  InfoRow,
  InfoColumn,
  TextWrapper,
  TopLine,
  Heading,
  Subtitle,
  ImgWrapper,
  Img
} from './InfoSection.elements';

function InfoSection({
  primary,
  lightBg,
  topLine,
  lightTopLine,
  lightText,
  lightTextDesc,
  headline,
  description,
  buttonLabel,
  img,
  bglight,
  alt,
  imgStart,
  start,
  boxsh
}) {
  return (
    <>
      <InfoSec lightBg={lightBg} boxsh={boxsh}>
        <Container>
          <InfoRow imgStart={imgStart}>
          <InfoColumn>
              <ImgWrapper start={start}>

                <Img src={img} alt={alt} />
              </ImgWrapper>
            </InfoColumn>
            <InfoColumn>
              <TextWrapper>
                <Heading lightText={true}>{headline}</Heading>
                <br />
                                <TopLine lightTopLine={lightTopLine} bglight={  bglight}
>{topLine}</TopLine>

                <Subtitle lightTextDesc={true}>{description}</Subtitle>
                {/* <Link to='/contactus'>
                  <Button big fontBig primary={primary}>
                    {buttonLabel}
                  </Button>
                </Link> */}
              </TextWrapper>
            </InfoColumn>
          </InfoRow>
        </Container>
      </InfoSec>
    </>
  );
}

export default InfoSection;
